import { checksumAddress, isAddress, isHash } from 'viem';

type FormatWalletAddressProps = {
  startChars?: number;
  endChars?: number;
  separator?: string;
};

/**
 * Formats a given Ethereum address by truncating the middle part and replacing it with a separator.
 *
 * @param address - The Ethereum address to format, transaction hashes are also supported.
 * @param options - An optional object to specify formatting options.
 * @param options.startChars - The number of characters to keep at the start of the address. Default is 5.
 * @param options.endChars - The number of characters to keep at the end of the address. Default is 4.
 * @param options.separator - The string to use as a separator between the start and end characters. Default is '…'.
 * @returns The formatted address if the input is a valid Ethereum address, otherwise returns the original input.
 */
export const formatAddress = (
  address = '',
  {
    startChars = 5,
    endChars = 4,
    separator = '…',
  }: FormatWalletAddressProps = {},
) => {
  if (!isAddress(address) && !isHash(address)) return address;
  const checksummedAddress = checksumAddress(address);
  return `${checksummedAddress.slice(0, startChars)}${separator}${checksummedAddress.slice(-endChars)}`;
};
